<template>
    <div class="flex flex-col h-full">
        <div class="max-w-none md:max-w-800 m-auto">

            <div v-if="! handoffUrl" class="flex flex-col items-center">
                <div class="fa-3x">
                    <h6 class="text-2xl"><i class="fa fa-spinner fa-spin text-2xl"/></h6>
                </div>
                <div class="mt-4 px-12 font-semibold text-center">
                    <p class="text-lg font-semibold animate-pulse">Please wait while we look at all your loan options...</p>
                </div>
            </div>
            <div v-else class="flex items-center">

                <div>
                    <p>Congratulations! You are approved for a loan from one of our partners.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['accounts', 'loan', 'handoffUrl'],

    data() {
        return {
            intervalId: null,
        }
    },

    methods: {
        // Same contract as Pause.vue: the buyer URL is never in this page. Submitting the
        // signed action is what claims the sale, and the server's 303 is the navigation.
        submitHandoff() {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = this.handoffUrl;
            form.style.display = 'none';

            const token = document.createElement('input');
            token.type = 'hidden';
            token.name = '_token';
            token.value = document.head.querySelector('meta[name="csrf-token"]')?.content || '';
            form.appendChild(token);

            document.body.appendChild(form);
            form.submit();
        },
    },

    mounted() {
        if (!this.intervalId && !this.handoffUrl) {
            this.intervalId = setInterval(() => {
                window.location = window.location;
            }, 10000);
        } else if (this.handoffUrl) {
            setTimeout(() => this.submitHandoff(), 3000);
        }
    },
}
</script>